import React, { createContext, useState } from 'react';
import { clearLocalStorageExceptThemeKeys } from '../Utilities/themeUserStorage';

const UserContext = createContext();

const UserProvider = ({ children }) => {
  const [user, setUser] = useState({
    accountType : ""
  });

  // Function to set the user data (e.g., after successful sign-in)
  const handleSignIn = (userData) => {
    setUser(userData);
  };

  // Function to clear user data (e.g., after sign-out)
  const handleSignOut = () => {
    setUser(null);
    clearLocalStorageExceptThemeKeys();
  };

  // Value to be provided to consuming components
  const contextValue = {
    user,
    signIn: handleSignIn,
    signOut: handleSignOut,
  };

  return <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>;
};

export { UserContext, UserProvider };
